export default "__VITE_ASSET__DSI5sTpu__"